const state = {
  fontFamily: 'Montserrat',
  colorText: 'light-blue',
  holiday: [],
  nextBusinessDay: null
}

// getters
const getters = {
  getFontFamily: (state) => {
    return state.fontFamily
  },
  getColorText: (state) => {
    return state.colorText
  },
  getHoliday: (state) => {
    return state.holiday
  },
  getNextBusinessDay: (state) => {
    return state.nextBusinessDay
  }
}

// actions
const actions = {}

// mutations
const mutations = {
  setFontFamily (state, payload) {
    state.fontFamily = payload
  },
  setColorText (state, payload) {
    state.colorText = payload
  },
  setHoliday (state, payload) {
    state.holiday = payload
  },
  setNextBusinessDay (state, payload) {
    state.nextBusinessDay = payload
  }
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations
}
